import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { CloseIcon, CollapseIcon, ExpandIcon } from './composerIcons';
import { composerStyles as styles } from './composerStyles';
import type { ComposerReplyType } from './types';

interface ComposerHeaderProps {
	replyType: ComposerReplyType;
	onReplyTypeChange: (type: ComposerReplyType) => void;
	expanded: boolean;
	onToggleExpanded: () => void;
	onClose: () => void;
}

interface HeaderTabProps {
	label: string;
	active: boolean;
	isNote?: boolean;
	onClick: () => void;
}

const HeaderTab: React.FC<HeaderTabProps> = ({ label, active, isNote, onClick }) => (
	<Button
		variant='ghost'
		size='sm'
		styles={[styles.tab, ...(active ? [styles.tabActive, ...(isNote ? [styles.tabActiveNote] : [])] : [])]}
		onClick={onClick}
	>
		{label}
	</Button>
);

/** Typographic Reply / Note tabs with the expand and close controls. */
export const ComposerHeader: React.FC<ComposerHeaderProps> = ({
	replyType,
	onReplyTypeChange,
	expanded,
	onToggleExpanded,
	onClose,
}) => (
	<div className={css(styles.headerRow)}>
		<div className={css(styles.tabs)}>
			<HeaderTab label='Reply' active={replyType === 'reply'} onClick={() => onReplyTypeChange('reply')} />
			<HeaderTab label='Note' active={replyType === 'note'} isNote onClick={() => onReplyTypeChange('note')} />
			{replyType === 'forward' && <HeaderTab label='Forward' active onClick={() => undefined} />}
		</div>
		<div className={css(styles.headerSpacer)} />
		<div className={css(styles.headerButtons)}>
			<Button
				variant='ghost'
				size='sm'
				styles={[styles.headerIconBtn]}
				onClick={onToggleExpanded}
				title={expanded ? 'Collapse' : 'Expand'}
				aria-label={expanded ? 'Collapse composer' : 'Expand composer'}
			>
				{expanded ? <CollapseIcon /> : <ExpandIcon />}
			</Button>
			<Button
				variant='ghost'
				size='sm'
				styles={[styles.headerIconBtn]}
				onClick={onClose}
				title='Close — draft is kept'
				aria-label='Close composer'
			>
				<CloseIcon />
			</Button>
		</div>
	</div>
);
